import React, { useEffect } from 'react';

export const MainScreen: React.FC = () => {
  useEffect(() => {
    if (__DEV__) return;

    window.location.href = 'https://m.a-bly.com/';
  }, []);
  return null;
};
